import React from 'react';
import { Icon } from '@/shared/icons'
import { Input } from '@/shared/components/ui'

interface UserSecuritySectionProps {
  formData: any;
  isEditMode: boolean;
  onFieldChange: (field: string, value: any) => void;
}

export const UserSecuritySection: React.FC<UserSecuritySectionProps> = ({
  formData,
  isEditMode,
  onFieldChange,
}) => {
  return (
    <div
      className="rounded-xl border overflow-hidden"
      style={{
        backgroundColor: 'var(--theme-card-background)',
        borderColor: 'var(--theme-card-border)',
      }}
    >
      {/* Section Header (.card-h) */}
      <div
        className="flex items-start gap-3 px-[18px] py-[15px] border-b"
        style={{ borderColor: 'var(--theme-card-border)' }}
      >
        <div
          className="w-[34px] h-[34px] rounded-[9px] flex items-center justify-center flex-shrink-0"
          style={{
            backgroundColor: 'var(--theme-primary-background)',
            color: 'var(--theme-primary)',
          }}
        >
          <Icon name="shield" className="w-5 h-5" />
        </div>
        <div>
          <h2 className="text-[15px] font-bold" style={{ color: 'var(--theme-card-text)' }}>
            Segurança
          </h2>
          <p className="text-xs" style={{ color: 'var(--theme-muted-text)' }}>
            {isEditMode
              ? 'Configurações de senha e autenticação'
              : 'Defina como o usuário acessará o sistema'}
          </p>
        </div>
      </div>

      {/* Form Fields (.card-b) */}
      <div className="space-y-4 p-[18px]">
        {/* Create Mode - Send Invite Option */}
        {!isEditMode && (
          <div
            onClick={() => onFieldChange('sendInvite', !formData.sendInvite)}
            className="flex items-start gap-3 p-4 cursor-pointer border"
            style={{
              backgroundColor: 'var(--theme-page-background)',
              borderColor: 'var(--theme-card-border)',
              borderRadius: 11,
            }}
            data-testid="users-form-send-invite"
          >
            <span
              className="flex items-center justify-center flex-none mt-0.5"
              style={{
                width: 17,
                height: 17,
                borderRadius: 5,
                border: '1.6px solid var(--theme-input-border)',
                backgroundColor: formData.sendInvite ? 'var(--theme-primary)' : 'var(--theme-input-background)',
                color: '#ffffff',
              }}
            >
              {formData.sendInvite && <Icon name="check" className="w-3 h-3" />}
            </span>
            <div className="flex-1">
              <div
                className="flex items-center gap-2 text-sm font-medium"
                style={{ color: 'var(--theme-card-text)' }}
              >
                <Icon name="mail" className="w-4 h-4" style={{ color: 'var(--theme-primary)' }} />
                Enviar convite por email
              </div>
              <p className="text-xs mt-1" style={{ color: 'var(--theme-muted-text)' }}>
                O usuário receberá um email com link para definir sua própria senha
              </p>
            </div>
          </div>
        )}

        {/* Password Fields (create mode without invite OR edit mode) */}
        {(!isEditMode && !formData.sendInvite) || isEditMode ? (
          <div className="space-y-4">
            {/* Password */}
            <div>
              <label
                className="block text-sm font-medium mb-2"
                style={{ color: 'var(--theme-card-text)' }}
              >
                Senha {!isEditMode && '*'}
              </label>
              <Input
                type="password"
                value={formData.password || ''}
                onChange={(e) => onFieldChange('password', e.target.value)}
                placeholder={isEditMode ? 'Deixe em branco para não alterar' : 'Mínimo 6 caracteres'}
                data-testid="users-form-password"
              />
              {isEditMode && (
                <p className="text-xs mt-1" style={{ color: 'var(--theme-muted-text)' }}>
                  Preencha apenas se desejar alterar a senha atual
                </p>
              )}
            </div>

            {/* Confirm Password (only show if password is filled) */}
            {formData.password && (
              <div>
                <label
                  className="block text-sm font-medium mb-2"
                  style={{ color: 'var(--theme-card-text)' }}
                >
                  Confirmar Senha {!isEditMode && '*'}
                </label>
                <Input
                  type="password"
                  value={formData.confirmPassword || ''}
                  onChange={(e) => onFieldChange('confirmPassword', e.target.value)}
                  placeholder="Digite a senha novamente"
                  data-testid="users-form-confirm-password"
                />
              </div>
            )}
          </div>
        ) : null}

        {/* Edit Mode - Additional Security Options (Future) */}
        {isEditMode && (
          <div className="pt-4 border-t" style={{ borderColor: 'var(--theme-card-border)' }}>
            <p className="text-sm" style={{ color: 'var(--theme-muted-text)' }}>
              Autenticação de dois fatores (2FA) será implementada em breve
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

UserSecuritySection.displayName = 'UserSecuritySection';
